import {
  FloatingLabel,
  InputGroup,
  Form,
  FormControlProps,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { forwardRef } from "react";
import {
  FormatarCPF,
  FormatarDouble,
  FormatarTelefone,
  SoNumeros,
  RemoverZerosEsquerda,
  FormatarCNPJ,
  TodasMaiusculas,
  FormatarCEP,
  Capitalizar,
  TodasMinusculas,
} from "src/hook/Functions";
import { FieldError } from "react-hook-form";

type InputProps = {
  label: string;
  type?: FormControlProps["type"];
  size?: FormControlProps["size"];
  errorsMessage?: FieldError | undefined;
  inputMask?:
    | "int"
    | "double"
    | "text"
    | "cpf"
    | "cnpj"
    | "cnpj-cpf"
    | "fone"
    | "data"
    | "datahora"
    | "minusculas"
    | "maiusculas"
    | "cep"
    | "capitalizar";
  maxLength?: number;
  disabled?: boolean | undefined;
  readOnly?: boolean | undefined;
  onInputChange?: (value: string) => void;
  registerField: any;
  tooltipMessage?: string;
  textAlign?: "center";
  autoComplete?: boolean;
};

export const FloatInputComponent = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      type = "text",
      size = "sm",
      errorsMessage,
      inputMask = "text",
      maxLength,
      disabled = undefined,
      readOnly = undefined,
      onInputChange,
      registerField,
      tooltipMessage = "",
      textAlign = undefined,
      autoComplete = false,
    },
    ref
  ) => {
    const {
      onChange: onChangeField,
      onBlur: onBlurField,
      name: nameField,
      ref: refField,
    } = registerField;

    if (inputMask === "data") {
      type = "date";
    }
    if (inputMask === "datahora") {
      type = "datetime-local";
    }

    const OnInputChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      const value = e.target.value;
      onInputChange && onInputChange(value);
      const sanitizedValue = RemoverZerosEsquerda(SoNumeros(value));
      const cursorPosition = e.target.selectionStart;
      const cursorPoritionEnd =
        e.target.selectionStart === e.target.value.length;

      const nativeEvent = e.nativeEvent as InputEvent;
      if (nativeEvent.inputType === "deleteContentBackward") {
        // A tecla Backspace foi pressionada
        // return;
      }

      if (inputMask === "double" || inputMask === "int") {
        if (sanitizedValue.length === 0) {
          e.target.value = "0";
          return;
        }
      }

      if (inputMask === "double") {
        e.target.value = FormatarDouble(sanitizedValue);
      }

      if (inputMask === "int") {
        e.target.value = sanitizedValue;
      }

      if (inputMask === "cpf") {
        e.target.value = FormatarCPF(value);
        if (!cursorPoritionEnd) {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      }

      if (inputMask === "cnpj") {
        e.target.value = FormatarCNPJ(value);
        if (!cursorPoritionEnd) {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      }

      if (inputMask === "cnpj-cpf") {
        if (SoNumeros(value).length === 14) {
          e.target.value = FormatarCNPJ(value);
        }
        if (SoNumeros(value).length === 11) {
          e.target.value = FormatarCPF(value);
        }
        if (!cursorPoritionEnd) {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      }

      if (inputMask === "fone") {
        e.target.value = FormatarTelefone(value);
      }

      if (inputMask === "maiusculas") {
        e.target.value = TodasMaiusculas(value);
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }

      if (inputMask === "minusculas") {
        e.target.value = TodasMinusculas(value);
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }

      if (inputMask === "cep") {
        e.target.value = FormatarCEP(value);
        if (!cursorPoritionEnd) {
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      }

      if (inputMask === "capitalizar") {
        e.target.value = Capitalizar(value);
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }
      onChangeField(e);
    };

    const inputElement = (
      <Form.Control
        type={type}
        placeholder={label}
        size={size}
        isInvalid={!!errorsMessage?.message}
        ref={refField}
        onChange={(e) => {
          OnInputChange(e);
        }}
        onBlur={onBlurField}
        name={`${nameField}`}
        maxLength={maxLength}
        disabled={disabled}
        readOnly={readOnly}
        className={textAlign === "center" ? "text-center" : ""}
        autoComplete={autoComplete === true ? "on" : ""}
      />
    );

    return (
      <>
        <InputGroup hasValidation>
          <FloatingLabel label={label}>
            {tooltipMessage ? (
              <OverlayTrigger
                placement="bottom-start"
                overlay={
                  <Tooltip id={`tooltip-${nameField}`}>
                    {tooltipMessage}
                  </Tooltip>
                }
                trigger={["hover", "focus"]}
              >
                {inputElement}
              </OverlayTrigger>
            ) : (
              inputElement
            )}
            {errorsMessage?.message?.toString() && (
              <Form.Control.Feedback type="invalid">
                {errorsMessage?.message?.toString()}
              </Form.Control.Feedback>
            )}
          </FloatingLabel>
        </InputGroup>
      </>
    );
  }
);
